<app-lms-modal-frame [title]="reportTitle" [pageHeadWidth]="600">
  <div modal-body class="p-0">
    <div class="container-fluid">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ reportTitle }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">Loan Number</th>
                <th scope="col">ID Number</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Created On</th>
                <th scope="col">Completed On</th>
                <th scope="col">Branch Name</th>
                <th scope="col">Branch Serial</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of completedBranchLoanslst | paginate: config">
                <td>{{ row.id }}</td>
                <td>{{ row.idNumber }}</td>
                <td>{{ row.firstName }}</td>
                <td>{{ row.lastName }}</td>
                <td>{{ row.createdOn }}</td>
                <td>{{ row.completedOn }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.branchSerial }}</td>
                <td>{{ row.status }}</td>
              </tr>
              <tr *ngIf="completedBranchLoanslst.length === 0">
                <td colspan="12" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'lms-data-report-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

      <div class="action-bar">
        <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
          <i class="fas fa-file-excel fa-fw"></i> Export to Excel
        </button>
        <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
      </div>

    </section>
    </div>
  </div>
</app-lms-modal-frame>
